import { createFileRoute } from "@tanstack/react-router";
import BlogAiVsRpa from "@/pages/BlogAiVsRpa";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/ai-vs-rpa-logistics")({
  head: () => pageHead("/blog/ai-vs-rpa-logistics", "en"),
  component: BlogAiVsRpa,
});
